import React, { FC } from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
export const ZTZB: FC<{ data: any }> = ({ data, ...props }) => {
    const option = {
        title: {
            // text: '资产分类',
        },
        tooltip: {
            // trigger: 'axis',
            // axisPointer: {
            //     type: 'shadow',
            // },
        },
        color:['#507AFF'],
        grid: {
            left: '1%',
            top:'10%',
            right: '10%',
            bottom: '15%',
            containLabel: true
          },
        legend: {},

        xAxis: {
            type: 'value',
            // boundaryGap: [0, 0.01],
        },
        yAxis: {
            type: 'category',
            data: data.map((item)=>item.typeName),
            axisTick: { show: false },
            inverse: true,
        },
        series: [
            {
                name: '',
                type: 'bar',
                data: data,
            //显示数值
            itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'right', //在上方显示
                    textStyle: {
                      //数值样式
                      color: 'black',
                      fontSize: 12,
                    },
                  },
                },
              }, 
  
            },
        ],
    }

    return <ReactEchartsCore className="secondImg" echarts={echarts} theme="bar" option={option as any} />
}
